import PropTypes from "prop-types";
import AppointmentNoteActions from "./AppointmentNoteActions";
import NoteCard from "./NoteCard";
import AssessmentCard from "../customForms/AssessmentCard";
import { useUserRole } from "../../hooks/useUserRole";

export default function VisitNotesGroup({ appointment, notes, items, userId, token, actions, onCorrectAssessment, onEnteredInErrorAssessment }) {
  const { getRoleForClinic } = useUserRole();
  const displayItems = items || notes;
  return (
    <section aria-labelledby={`visit-${appointment.id}`} className="border-l-2 border-blue-200 pl-4">
      <header className="mb-3 flex flex-wrap items-start justify-between gap-3">
        <div>
          <h3 id={`visit-${appointment.id}`} className="font-semibold text-slate-900">
            {new Date(appointment.date_time).toLocaleDateString()} · {new Date(appointment.date_time).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
          </h3>
          <p className="text-xs text-slate-500">
            Dr. {appointment.doctorName} · {appointment.status}{appointment.clinicName ? ` · ${appointment.clinicName}` : ""}
          </p>
        </div>
        <AppointmentNoteActions appointmentId={appointment.id} notes={notes} hasClinicalContent={displayItems.length > 0} token={token} />
      </header>
      <div className="space-y-3">
        {displayItems.map(item => {
          if (item.kind === 'assessment') {
            return <AssessmentCard
              key={item.id}
              assessment={item}
              template={item.template}
              version={item.version}
              latestRevision={item.latestRevision}
              revisionHistory={item.revisionHistory}
              userId={userId}
              canAdminister={getRoleForClinic(item.clinic_id) === 'admin'}
              onCorrect={onCorrectAssessment}
              onEnteredInError={onEnteredInErrorAssessment}
            />;
          }
          return <NoteCard
            key={item.id} note={item} userId={userId} token={token}
            onDelete={actions.deleteNote} onRetry={actions.retryMediaUpload}
            isUploading={actions.uploadingNoteId === item.id}
          />;
        })}
      </div>
    </section>
  );
}

VisitNotesGroup.propTypes = {
  appointment: PropTypes.object.isRequired,
  notes: PropTypes.arrayOf(PropTypes.object),
  items: PropTypes.arrayOf(PropTypes.object),
  userId: PropTypes.string.isRequired,
  token: PropTypes.string,
  actions: PropTypes.shape({ deleteNote: PropTypes.func.isRequired, retryMediaUpload: PropTypes.func.isRequired, uploadingNoteId: PropTypes.string }).isRequired,
  onCorrectAssessment: PropTypes.func,
  onEnteredInErrorAssessment: PropTypes.func,
};
